@if (availableProducts$ | async; as availableProducts) {
  <tui-textfield
    tuiChevron
    [stringify]="stringifyFn"
    [tuiTextfieldCleaner]="true"
    tuiTextfieldSize="m"
  >
    <input
      placeholder="Выберите"
      tuiSelect
      [(ngModel)]="value"
      (ngModelChange)="valueChanged($event)"
    />
    <ng-template tuiDropdown>
      <tui-data-list>
        @for (
          availableProduct of availableProducts;
          track availableProduct.id
        ) {
          <button tuiOption [value]="availableProduct">
            {{ availableProduct.name }}
          </button>
        }
      </tui-data-list>
    </ng-template>
  </tui-textfield>
}
